(function () {


	angular.module('app.widgets')
	.directive('buscadorDocumento', buscadorDocumento); 

    buscadorDocumento.$inject = ['ApiBaseService', 'moment', 'UserInfoService'];

	function buscadorDocumento(ApiBaseService, moment, UserInfoService) {
        return {
            restrict: 'E',
            templateUrl: 'app/widgets/buscadorDocumento.html',
            scope: {
                desde: '=',
                hasta: '=',
                tipoDocumentoId: '=',
                emisorId: '=',
                receptorId: '=',
                verReceptor: '@',
                verTipoDocumento: '@',
                searchKey: '@',
                accionBuscarCallback: '&',
                accionGetExcelCallback: '&'
            },
            controllerAs: 'vm',
            controller: function($scope){
                var vm = this;

                vm.verReceptor = $scope.verReceptor;
                vm.verTipoDocumento = $scope.verTipoDocumento;

                vm.clearCriteria = function(){
                    $scope.vm.desde = moment().add(-7, 'days').toDate();
                    $scope.vm.hasta = moment().toDate();
                    $scope.vm.tipoDocumentoId = 0;
                    $scope.vm.emisorId = 0;
                    $scope.vm.receptorId = 0;
                };
                
                vm.clearCriteria();
                cargarPreviousSearch($scope.searchKey)

                vm.tipoDocumentos = [];
                vm.emisores = [];
                vm.receptores = [];

                if(vm.verTipoDocumento == "true")
                {
                   getComboData(vm.tipoDocumentos, 'api/TipoDocumentos', null, 'Error al obtener los tipos de documento.'); 
                }

                if(vm.verReceptor == "true")
                {
                    getComboData(vm.receptores, 'api/Receptores', null, 'Error al obtener los receptores.');
                }
                
                getComboData(vm.emisores, 'api/Emisores', null, 'Error al obtener los emisores.');
                

                vm.openFechaDesde = function(){
                    vm.fechaDesdeOpened = !vm.fechaDesdeOpened;
                };
        
                vm.openFechaHasta = function(){
                    vm.fechaHastaOpened = !vm.fechaHastaOpened;
                };

                function getParams(){
                    const params = {
                        desde: $scope.vm.desde,
                        hasta: $scope.vm.hasta,
                        tipoDocumentoId: $scope.vm.tipoDocumentoId,
                        emisorId: $scope.vm.emisorId,
                        receptorId: $scope.vm.receptorId,
                    };
                    if(params.receptorId !== 0)
                    {
                        params.receptorId = vm.receptores.find(e=>e.id === params.receptorId).numeroIdentificacion;
                    }

                    return params;
                };

                vm.getExcel = function(){

                    const params = getParams();

                    $scope.accionGetExcelCallback({criterios: params});
                };

                vm.buscar = function(){

                    const params = getParams();

                    $scope.accionBuscarCallback({criterios: params});
                };

                function getComboData(array, apiUrl, params, errorMessage){
                    ApiBaseService.remoteController = apiUrl;
                    var promise = ApiBaseService.getAll(params)
                    .then(function(data){
                        array.splice(0);
                        array.push(...data);
                    })
                    .catch(function(error){
                        $logger.error(errorMessage);
                    }); 
                    
                    return promise;
                };

                function cargarPreviousSearch(searchKey){
                    
                    if(!searchKey) return;

                    var previousSearch = UserInfoService.getDataFromSessionStorage(searchKey);
                    if(previousSearch){
                        $scope.vm.desde = moment(previousSearch.desde).toDate();
                        $scope.vm.hasta = moment(previousSearch.hasta).toDate();
                        $scope.vm.tipoDocumentoId = previousSearch.tipoDocumentoId;
                        $scope.vm.emisorId = previousSearch.emisorId;
                        $scope.vm.receptorId = previousSearch.receptorId; 
                    }
                };

            }
        }
    }

})();